import { Global } from "@emotion/react";
import { AuthProvider } from "@ssf/auth-components";
import { AppWrapper, Page, playTheme, queryClient } from "@ssf/components";
import bgImageAvif from "@ssf/components/assets/bg.avif";
import bgImageJpg from "@ssf/components/assets/bg.jpg";
import bgImageWebp from "@ssf/components/assets/bg.webp";
import { setAuthorization as setMemdbAuthorization } from "@ssf/memdb-api";
import { trpcClient, trpcContext } from "@ssf/play-components";
import { QueryClientProvider } from "@tanstack/react-query";

import {
  FirebaseConnectionStatus,
  Header,
  Router,
} from "./components/index.js";
import { i18next, PlayerProvider } from "./lib/index.js";

export const App = () => (
  <>
    <AppWrapper env={import.meta.env} theme={playTheme} i18n={i18next}>
      <trpcContext.TRPCProvider
        trpcClient={trpcClient}
        queryClient={queryClient}
      >
        <QueryClientProvider client={queryClient}>
          <AuthProvider
            onUser={(user) => {
              setMemdbAuthorization(user?.access_token);
            }}
          >
            <PlayerProvider>
              <Page>
                <Header />
                <Router />
              </Page>
              <FirebaseConnectionStatus />
            </PlayerProvider>
          </AuthProvider>
        </QueryClientProvider>
      </trpcContext.TRPCProvider>
    </AppWrapper>
    <Global
      styles={{
        body: {
          backgroundImage: `url(${bgImageJpg})`,
          "html.webp &": { backgroundImage: `url(${bgImageWebp})` },
          "html.avif &": { backgroundImage: `url(${bgImageAvif})` },
          backgroundSize: "contain",
          backgroundPosition: "50% 0",
        },
      }}
    />
  </>
);
